import React from "react";
import "./status-new.scss";
import { FluentBadge } from "../../../../../components/FluentUI/Fluent-Badge";
import { FluentTooltip } from "../../../../../components/FluentUI/Fluent-Tooltip";

const statusMap = {
  "Not Started": "not-started",
  "In Progress": "in-progress",
  Declined: "in-progress",
  Submitted: "submitted",
  "Awaiting Approval": "awaiting-approval",
  "Pending Review": "awaiting-approval",
  "Assigned - Pending review": "awaiting-approval",
  "Pending Approval": "awaiting-approval",
  Inactive: "inactive",
  Completed: "completed",
  Closed: "completed",
  Approved: "completed",
  Cancelled: "cancelled",
  Archived: "not-started",
  Active: "active",
  Overdue: "cancelled",
  "Fintrac Error": "cancelled",
  "Approved for Filing" : "approved-for-filing",
  "Approved for Not Filing" : "approved-for-not-filing",
};

const StatusNew = ({ status }) => {
  const trimStatus = (status) => {
    if (status?.length > 18) {
      return status.substring(0, 18) + "...";
    }
    return status;
  };

  const className = statusMap[status]
    || (status?.startsWith("Archived") ? "not-started" : "");

  return (
    <FluentTooltip
      target={
        <div className={className + " no-pointer width-fit-content"}>
          <FluentBadge
            shape="rounded"
            appearance="tint"
            size="extra-large"
            text={trimStatus(status)}
          ></FluentBadge>
        </div>
      }
      text={status}
    ></FluentTooltip>
  );
};

export default StatusNew;
